module.exports = __webpack_public_path__ + "img/299.8718f052.png";